import { render } from "./WSoportes.vue?vue&type=template&id=7e0fed77&scoped=true"
import script from "./WSoportes.vue?vue&type=script&lang=js"
export * from "./WSoportes.vue?vue&type=script&lang=js"

import "./WSoportes.vue?vue&type=style&index=0&id=7e0fed77&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e0fed77"]])

export default __exports__